import { AsidePanelActionsButton } from '../../../../..';
import * as React from 'react';
import { ICardPropertiesPanelButtonProps } from './types';
import { BOARD_SECTION_CARD_PROPERTIES_BUTTON } from '../../constants';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';

export function CardPropertiesPanelButton ({
    indicatorNumber,
    onClick
}: ICardPropertiesPanelButtonProps) {
    const { subTab, setSubTab } = React.useContext(AsidePanelContext);
    return (
        <AsidePanelActionsButton
            children={null}
            isOpened={subTab === EBoardSetting.CARD_PROPERTIES}
            indicatorNumber={indicatorNumber}
            title={BOARD_SECTION_CARD_PROPERTIES_BUTTON}
            onClick={() => {
                setSubTab(EBoardSetting.CARD_PROPERTIES);
                onClick();
            }}
        />
    );
}
